import { Component, Vue } from 'vue-property-decorator';
import { OnlinePortalRoutes } from '@/OnlinePortalRoutes';

@Component
export default class RouteMixin extends Vue {
	OnlinePortalRoutes = OnlinePortalRoutes;
}
